import { createContext, useContext } from "react"

import { LogsInitContext } from "../LogsInitComponentesContext/LogsInitComponentesContext"
import moment from "moment/moment"

export const TimersContext = createContext()

let Timers = {}
let started = false

export const TimersProvider = ({ children }) => {
    const { LogInit } = useContext(LogsInitContext)
    LogInit('TimersContext', 'contexto')

    if (!started) {
        setInterval(() => {
            reloadTimers()
        }, 1000)
        started = true
    }

    function reloadTimers() {
        const keys = Object.keys(Timers)
        for (const key of keys) {
            const a = Timers[key].dt_ini
            const b = moment().diff(a, 'seconds')
            const convert = ConverteSegundosParaMinutos(b)

            if (typeof Timers[key].changeColor === 'function') {
                Timers[key].changeColor(Timers[key].id_card, b, Timers[key].tipo_card)
            }

            let id = Timers[key].id_div
            let el = document.getElementById(id)
            if (el) {
                el.innerHTML = convert
            }
        }
    }

    const addTimer = (id_div, timestamp) => {
        if (!id_div || !timestamp) {
            return false
        }

        if (Timers[id_div] != undefined) {
            rmTimer(id_div, false)
        }

        const dt = moment.unix(timestamp).utc()
        // let teste = dt.format('DD/MM/YYYY HH:mm:ss')

        // Timers[id_div] = { id_div: id_div, dt_ini: dt, changeColor: callback, id_card: id_card, tipo_card: tipo_card};
        Timers[id_div] = { id_div, dt_ini: dt }
        return true
    }

    const rmTimer = (id_div, remove_tela = true) => {
        delete Timers[id_div]
        let el = document.getElementById(id_div)
        if (remove_tela) {
            if (el) {
                el.remove()
            }
        } else {
            if (el) {
                el.innerHTML = ''
            }
        }
        return true
    }

    const ConverteSegundosParaMinutos = (secs) => {
        let hours = Math.floor(secs / 3600) || 0
        let minutes = Math.floor(secs % 3600 / 60) || 0
        let seconds = Math.floor(secs % 3600 % 60) || 0

        if (hours >= 1) {
            return (hours < 10 ? '' : '') + hours + 'h ' + (minutes < 10 ? '' : '') + minutes + 'm ' + (seconds < 10 ? '' : '') + seconds + 's'
        } else if (minutes == 0) {
            return (seconds < 10 ? '' : '') + seconds + 's'
        } else {
            return '' + (minutes < 10 ? '' : '') + minutes + 'm ' + (seconds < 10 ? '' : '') + seconds + 's'
        }
    }

    const value = { addTimer, rmTimer }
    return (
        <TimersContext.Provider value={value}>
            <div>
                {children}
            </div>
        </TimersContext.Provider>
    )
}
